export const BANK_ADD = "BANK_ADD";
export const BANK_LIST = "BANK_LIST";
export const BANK_UPDATE = "BANK_UPDATE";
export const BANK_REQUEST = "BANK_REQUEST"
export const CLEAR_ERRORS = "CLEAR_ERRORS";